<template>
  <el-dialog
    v-drag
    title="清关要素"
    :visible.sync="dialogVisible"
    width="1033px"
    :append-to-body="true"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :before-close="cancel"
  >
    <div v-loading="loading" class="content">
      <div class="nav">
        <div class="nav-item" :class="renderClass('PRE_CLEARANCE')">
          <div class="icon">
            <i class="el-icon-check" />
          </div>
          <span>清关前</span>
          <div class="line"></div>
        </div>
        <div class="nav-item" :class="renderClass('IN_CLEARANCE')">
          <div class="icon">
            <i class="el-icon-check" />
          </div>
          <span>清关中</span>
          <div class="line"></div>
        </div>
        <div class="nav-item" :class="renderClass('POST_CLEARANCE')">
          <div class="icon">
            <i class="el-icon-check" />
          </div>
          <span>清关后</span>
        </div>
      </div>
      <div class="table">
        <div class="item" :class="renderClass('PRE_CLEARANCE')">
          <div class="top">
            <svg-icon iconClass="claerance" className="icon" />
            清关前
          </div>
          <div class="detail">
            <div v-for="(file, i) in fileList[0]" :key="i" class="child-item">
              <span>
                {{ file.name }}
              </span>
              <i class="icon" :class=" file.status === 'SUBMITTED' ? 'el-icon-success' : 'el-icon-circle-check' " :style="{'color': file.status === 'SUBMITTED' ? '#35BA83' : ''}" />
            </div>
          </div>
        </div>
        <div class="item" :class="renderClass('IN_CLEARANCE')">
          <div class="top">
            <svg-icon iconClass="claerance" className="icon" />
            清关中
          </div>
          <div class="detail">
            <div v-for="(file, i) in fileList[1]" :key="i" class="child-item">
              <span>
                {{ file.name }}
              </span>
              <i class="icon" :class=" file.status === 'SUBMITTED' ? 'el-icon-success' : 'el-icon-circle-check' " :style="{'color': file.status === 'SUBMITTED' ? '#35BA83' : ''}" />
            </div>
            <div v-if="clearanceData.inspection?.hasInspection" class="check">
              <div v-for="(item, i) in clearanceData.inspection?.list" :key="i" class="check-item">
                <span>
                  <img src="@/assets/images/bill/cy-icon.png" />
                  {{ item.typeName }}
                  <el-popover
                    placement="bottom"
                    width="130"
                    trigger="hover">
                    <div style="color: #666666;">
                      <p>环节 <span style="margin-left: 14px;color: #1D2129;">清关中查验</span></p>
                      <p>凭证 <span style="margin-left: 14px;color: #08A363;">{{ item?.certificateFileUrl ? '无' : item?.certificateStatus === 'UPLOADED' ? '已上传' : '待上传' }}</span></p>
                    </div>
                    <i slot="reference" class="el-icon-question" style="color: #CF4617" />
                  </el-popover>
                </span>
                <span class="date">
                  {{ item.time }}
                </span>
              </div>
            </div>
          </div>
        </div>
        <div class="item" :class="renderClass('POST_CLEARANCE')">
          <div class="top">
            <svg-icon iconClass="claerance" className="icon" />
            清关后
          </div>
          <div class="detail">
            <div class="child-item">
              <span>
                清关放行
              </span>
              <i class="icon" :class="clearanceData.releaseStatus?.released ? 'el-icon-success' : 'el-icon-circle-check' " :style="{'color': clearanceData.releaseStatus?.released ? '#35BA83' : ''}" />
            </div>
            <div class="child-item">
              <span>
                完结
              </span>
              <i class="icon" :class="clearanceData.completed ? 'el-icon-success' : 'el-icon-circle-check' " :style="{'color': clearanceData.completed ? '#35BA83' : ''}" />
            </div>
          </div>
        </div>
      </div>
      <div class="bottom">
        <div class="item">
          <img src="@/assets/images/bill/qggj.png" />
          <div class="des">
            <p>
              <span class="label">清关轨迹</span>
              <span class="date">{{ clearanceData.traces?.clearanceTrace?.updateTime }}</span>
            </p>
            <p class="value">{{ clearanceData.traces?.clearanceTrace?.message }}</p>
          </div>
        </div>
        <div class="item">
          <img src="@/assets/images/bill/csgj.png" />
          <div class="des">
            <p>
              <span class="label">船司轨迹</span>
              <span class="date">{{ clearanceData.traces?.shippingTrace?.updateTime }}</span>
            </p>
            <p class="value">{{ clearanceData.traces?.shippingTrace?.message }}</p>
          </div>
        </div>
      </div>
    </div>
  </el-dialog>
</template>
<script>
const PRE_CLEARANCE = 'PRE_CLEARANCE'
const IN_CLEARANCE = 'IN_CLEARANCE'
const POST_CLEARANCE = 'POST_CLEARANCE'
import { getClearanceStatus } from '@/api/bill'
export default {
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    rowData: {
        type: Object,
        default: () => {}
    }
  },
  data() {
    return {
      loading: false,
      clearanceData: {}
    }
  },
  computed: {
    fileList() {
        return [
            this.clearanceData.documents?.filter(a => a.stage === PRE_CLEARANCE),
            this.clearanceData.documents?.filter(a => a.stage === IN_CLEARANCE)
            // this.clearanceData.documents?.filter(a => a.stage === POST_CLEARANCE)
        ]
    }
  },
  watch: {
    dialogVisible(val) {
        if (val) {
            this.getData()
        }
    }
  },
  methods: {
    async getData() {
        try {
        this.loading = true
         const res = await getClearanceStatus({ mblId: this.rowData.id })
         this.loading = false
         if (res.success) {
            this.clearanceData = res.data
         } else {
            this.$message.error(res.errorMessage)
         }
        } catch (error) {
            console.log(error)
        }
    },
    cancel() {
      this.$emit('cancel')
      this.$refs['form'].resetFields()
    },
    renderClass(step) {
        let className = ''
        switch (step) {
            case PRE_CLEARANCE:
                if (this.clearanceData.currentStage === step) {
                    className = 'ing' // over  ing
                } else {
                    className = 'over' // over  ing
                }
            break
            case IN_CLEARANCE:
                if (this.clearanceData.currentStage === PRE_CLEARANCE) {
                    className = '' // over  ing
                } else if (this.clearanceData.currentStage === step) {
                    className = 'ing' // over  ing
                } else {
                    className = 'over' // over  ing
                }
            break
            case POST_CLEARANCE:
                if (this.clearanceData.currentStage === PRE_CLEARANCE) {
                    className = '' // over  ing
                } else if (this.clearanceData.currentStage === IN_CLEARANCE) {
                    className = '' // over  ing
                } else {
                    className = 'ing' // over  ing
                }
            break
        }
        return className
    }
  }
}
</script>
<style lang="less" scoped>
/deep/ .el-dialog__body {
  padding: 20px 20px;
}
.content {
  box-sizing: border-box;
  .nav {
    width: 100%;
    height: 40px;
    background: #F7F8FA;
    border-radius: 6px 6px 6px 6px;
    display: flex;
    justify-content: center;
    align-items: center;
    .nav-item {
        width: 306px;
        height: 24px;
        display: flex;
        & + .nav-item {
            margin-left: 12px;
        }
        .icon {
            width: 24px;
            height: 24px;
            background: #DDDDDE;
            border-radius: 32px 32px 32px 32px;
            text-align: center;
            line-height: 24px;
        }
        span {
            margin-left: 12px;
            font-family: Microsoft YaHei, Microsoft YaHei;
            font-weight: bold;
            font-size: 14px;
            color: #E5E6EB;
            line-height: 24px;
        }
        .line {
            width: 202px;
            height: 0px;
            margin-left: 12px;
            border-radius: 0px 0px 0px 0px;
            border: 1px solid #E5E6EB;
            margin-top: 11px;
        }
    }
    .over {
          .icon {
            background: #E8F3FF;
            color: #35BA83
          }
          span {
            color: #1D2129;
          }
          .line {
            border: 1px solid #35BA83;
          }
    }
    .ing {
          .icon {
            background: #35BA83;
            color: #fff
          }
          span {
            color: #35BA83;
          }

    }
  }
  .table {
    width: 100%;
    height: auto;
    display: flex;
    margin-top: 12px;
    .item {
        width: 320px;
        height: 346px;
        background: #FFFFFF;
        box-shadow: 0px 0px 6px 0px rgba(102,102,102,0.15);
        border-radius: 6px 6px 6px 6px;
        box-sizing: border-box;
            position: relative;
        & + .item {
            margin-left: 12px;
        }
        .top {
            width: 100%;
            height: 36px;
            background: #F7F8FA;
            box-sizing: border-box;
            padding-left: 16px;
            line-height: 36px;
            font-family: Microsoft YaHei, Microsoft YaHei;
            font-weight: 400;
            font-size: 12px;
            color: #666666;
            .icon {
                font-size: 16px;
            }
        }
        .detail {
            width: 100%;
            height: auto;
            box-sizing: border-box;
            padding: 12px 16px;
            .check {
                position: absolute;
                bottom: 20px;
                width: 284px;
                height: auto;
            }
            .check-item {
                width: 100%;
                height: 32px;
                background: #FFF7E8;
                box-shadow: 0px 4px 6px 0px rgba(255,247,232,0.2);
                border-radius: 6px 6px 6px 6px;
                padding: 8px 10px;
                box-sizing: border-box;
                font-family: Microsoft YaHei, Microsoft YaHei;
                font-weight: 400;
                font-size: 12px;
                color: #666666;
                line-height: 16px;
                display: flex;
                justify-content: space-between;
                & + .check-item {
                    margin-top: 6px;
                }
                span {
                    color: #CF4617;
                }
                .date {
                    color: #666666;
                }
             }
        }
        .child-item {
            width: 100%;
             box-sizing: border-box;
            height: 32px;
            background: rgba(255,255,255,0.9);
            box-shadow: 6px 0px 20px 0px rgba(34,87,188,0.1);
            border-radius: 4px 4px 4px 4px;
            padding: 0 10px;
            font-family: Microsoft YaHei, Microsoft YaHei;
            font-weight: 400;
            font-size: 12px;
            color: #999999;
            line-height: 32px;
            display: flex;
            justify-content: space-between;
            .icon {
                font-size: 16px;
                margin-top: 8px;
            }
            & + .child-item {
                margin-top: 4px;
            }
        }
    }
    .over {
       box-shadow: 0px 0px 6px 0px rgba(53,186,131,0.12);
        border-radius: 6px 6px 6px 6px;
        border: 1px solid #F6FFFB;
         .top {
            background: #F3FFFA;
           color: #35BA83;
         }
    }
    .ing {
       border: 2px solid #35BA83;
       box-shadow:none;
       .top {
          background: #35BA83;
              color: #FFFFFF;
         }
    }
  }
  .bottom {
    width: 100%;
    display: flex;
    margin-top: 12px;
    .item {
        width: calc(50% - 8px);
        height: 76px;
        background: #FFFFFF;
        box-shadow: 0px 0px 6px 0px rgba(102,102,102,0.12);
        border-radius: 6px 6px 6px 6px;
        box-sizing: border-box;
        padding: 18px 12px 18px 20px;
        display: flex;
        & + .item {
            margin-left: 16px;
        }
        .des {
            margin-left: 16px;
            width: 100%;
        }
        p {
            width: 100;
            display: flex;
            justify-content: space-between;
        }
        .label {
            height: 20px;
            font-family: Microsoft YaHei, Microsoft YaHei;
            font-weight: bold;
            font-size: 12px;
            color: #4E5969;
            line-height: 20px;
        }
        .date {
            height: 20px;
            font-family: Microsoft YaHei, Microsoft YaHei;
            font-weight: 400;
            font-size: 12px;
            color: #999999;
            line-height: 20px;
        }
        .value {
            height: 20px;
            font-family: Microsoft YaHei, Microsoft YaHei;
            font-weight: 400;
            font-size: 14px;
            color: #333333;
            line-height: 20px;
        }
    }
  }
}
</style>
